
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsc6593a7090dd3b2f811cd0e54c8d4a6een from './en.yaml'
            i18n.addResourceBundle('en', 'c6593a7090dd3b2f811cd0e54c8d4a6e', flattenObject(nsc6593a7090dd3b2f811cd0e54c8d4a6een), true, true);
        
        export default 'c6593a7090dd3b2f811cd0e54c8d4a6e';
    